import { CountryModel, DataSetupSelectOption, NationalityModel } from '@core/data-access';
import { FormlySelectOption } from '@ngx-formly/core/select';
import { PERSONNEL_OTHER, PersonnelEntity } from '@portal/application/data-access';

export function mapDataSetupSelectOptionToFormly(options: DataSetupSelectOption[] | undefined | null): FormlySelectOption[] {
  return options?.map(o => ({ label: o.value, value: o.key })) || [];
}

export function mapCountriesToFormlySelectOption(countries: CountryModel[] | null): FormlySelectOption[] {
  return countries?.map(o => ({ label: o.name, value: o.id })) || [];
}

export function mapNationalitiesToFormlySelectOption(nationalities: NationalityModel[] | null): FormlySelectOption[] {
  return nationalities?.map(o => ({ label: o.nationality, value: o.id })) || [];
}

export function mapPersonnelsEntityToFormlySelectOption(personnels: PersonnelEntity[]): FormlySelectOption[] {
  const options = personnels.map(personnel => ({
    label: personnel.data.name,
    value: personnel.id,
    disabled: false,
  }));

  options.push({ label: 'Other', value: PERSONNEL_OTHER, disabled: false });

  return options;
}
